<div class="row wrapper border-bottom white-bg page-heading">
	<div class="col-lg-10">
		<h2>Dados Adicionais - Item</h2>
		<h3>Admin</h3>
	</div>
	<div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-content box-content">
					<div class="info-page">
						<h3>{{ actionLabel }}</h3>
					</div>

					<form [formGroup]="form" (ngSubmit)="salvar()">
						<input type="hidden" formControlName="id" />

						<div class="form-group row m-b">
							<div class="col-sm-4">
								<label class="col-sm-12 pb-1">Título</label>
								<input type="text" id="title" class="form-control" formControlName="title" required maxlength="255" />
								<app-field-message [field]="fieldMessageRequired('title') || _erros?.title" [textErroServer]="_erros?.title" [erros]="fieldErros('title')"></app-field-message>
							</div>
						</div>

						<div class="form-group row m-b">
							<div class="col-sm-4">
								<label class="col-sm-12 pb-1">Máscara</label>
								<input type="text" id="title" class="form-control" formControlName="report_title" required maxlength="255" />
								<app-field-message [field]="fieldMessageRequired('report_title')" [textErroServer]="_erros?.report_title" [erros]="fieldErros('report_title')"></app-field-message>
							</div>
						</div>

						<div class="form-group row m-b">
							<div class="col-sm-4">
								<label class="col-sm-12 pb-1">Link</label>
								<input type="text" id="ref_link" class="form-control" formControlName="ref_link" maxlength="2083" />
								<app-field-message [field]="fieldMessageRequired('ref_link')" [textErroServer]="_erros?.ref_link" [erros]="fieldErros('ref_link')"></app-field-message>
							</div>
						</div>

						<div class="form-group row m-b">
							<div class="col-sm-4">
								<label class="col-sm-12 pb-1">Tipo</label>
								<ng-select id="type_id" class="ng-select-alternative" [items]="tiposArray" bindLabel="label" bindValue="id" formControlName="type_id" placeholder="Selecione">
								</ng-select>
								<app-field-message [field]="fieldMessageRequired('type_id')" [textErroServer]="_erros?.type_id" [erros]="fieldErros('type_id')"></app-field-message>
							</div>
						</div>

						<!-- Tipo Texto type_id=1 ou Combo type_id=5, exibe campo Tamanho max_length -->
						<div class="form-group row m-b" *ngIf="type_id.value == 1 || type_id.value == 5">
							<div class="col-sm-4">
								<label class="col-sm-12 pb-1">Tamanho</label>
								<input type="text" id="max_length" class="form-control" formControlName="max_length" maxlength="255" />
								<app-field-message [field]="fieldMessageRequired('max_length')" [textErroServer]="_erros?.max_length" [erros]="fieldErros('max_length')"></app-field-message>
							</div>
						</div>

						<!-- Tipo Numérico type_id=4, exibe campo Casas Decimais dec_places -->
						<div class="form-group row m-b" *ngIf="type_id.value == 4">
							<div class="col-sm-4">
								<label class="col-sm-12 pb-1">Casas Decimais</label>
								<ng-select id="dec_places" class="ng-select-alternative" [items]="casasDecimaisArray" bindLabel="label" bindValue="id" formControlName="dec_places" placeholder="Selecione">
								</ng-select>
								<app-field-message [field]="fieldMessageRequired('dec_places')" [textErroServer]="_erros?.dec_places" [erros]="fieldErros('dec_places')"></app-field-message>
							</div>
						</div>

						<!-- Tipo Combo type_id=5, exibe campo Opção combo -->
						<div *ngIf="type_id.value == 5" class="form-group row m-b">
							<div class="col-sm-4">
								<label class="col-sm-12 pb-1">Opções no combo:</label>
								<div *ngIf="opcoesCombo.length == 0">
									<span class="text-muted">Nenhuma opção cadastrada.</span>
								</div>
								<div formArrayName="opcoesCombo">
									<div *ngFor="let opcao of opcoesCombo.controls; let i = index" class="input-container">
										<div class="input-group" [formGroup]="opcao" [ngClass]="{'has-error': opcao.invalid && (opcao.dirty || opcao.touched) }">
											<input formControlName="opcao_id" type="hidden">
											<input formControlName="question_id" type="hidden">
											<input formControlName="ds_value" class="form-control m-b" type="text" required>
											<span class="input-group-append">
												<button class="btn btn-primary btn-remove" type="button" (click)="removeInput(i)" [disabled]="opcao.get('ds_value').disabled"><img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Excluir" placement="bottom"></button>
											</span>
										</div>
										<div *ngIf="opcao.invalid && (opcao.dirty || opcao.touched)" class="error">
											<label class="error">
												Digite o nome da opção.
											</label>
										</div>
									</div>
								</div>
								<br>
								<button class="btn btn-primary" type="button" (click)="addInput()">Nova opção</button>
							</div>
						</div>

						<div class="form-group row m-b">
							<div class="col-sm-4">
								<label class="col-sm-12 pb-1">Ativo</label>
								<ng-select id="actived" class="ng-select-alternative" [items]="ativoArray" bindLabel="label" bindValue="id" formControlName="actived" placeholder="Selecione">
								</ng-select>
								<app-field-message [field]="fieldMessageRequired('actived')" [textErroServer]="_erros?.actived" [erros]="fieldErros('actived')"></app-field-message>
							</div>
						</div>

						<div class="hr-line-dashed"></div>
						<div class="form-group row d-flex justify-content-end">
							<div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
								<button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
								<button class="btn btn-primary" type="submit">Salvar</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>

<app-loading [loader]="isLoading"></app-loading>